import { UpdatableModel } from '../../models/updatable-model';

export class ImpersonateDialogResponse extends UpdatableModel<ImpersonateDialogResponse> {
  continue: boolean;
  discontinuePrompt: boolean;
}
